import React from 'react';
import {
  Button,
  TextField,
  Typography,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Chip,
  Grid,
} from '@material-ui/core';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  EmojiEvents as AwardIcon,
  Person as PersonIcon,
  Group as GroupIcon,
} from '@material-ui/icons';
import { ComissionBonusCondition } from '../../../../helpers/enums';

const COLORS = {
  individual: {
    primary: '#455a64',
    light: '#f5f5f5',
    border: '#cfd8dc',
  },
  group: {
    primary: '#37474f',
    light: '#fafafa',
    border: '#e0e0e0',
    chip: '#455a64',
  },
  action: '#FF5246',
};

const formatCurrencyInput = value => {
  if (!value && value !== 0) {
    return '';
  }
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(numValue)) {
    return '';
  }
  return numValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const handleCurrencyChange = (e, updateFn, index, field) => {
  // Remove tudo exceto dígitos
  const rawValue = e.target.value.replace(/\D/g, '');
  // Converte centavos para reais (ex: 32600 -> 326.00)
  const numericValue = rawValue ? parseInt(rawValue, 10) / 100 : '';
  updateFn(index, field, numericValue);
};

const Bonus = ({
  formData,
  addBonus,
  removeBonus,
  updateBonus,
  createBonusGroup,
  removeGroup,
  aggregateBonusGroups,
  getBonusesByGroup,
  getIndividualBonuses,
  classes,
}) => {
  return (
    <div className={classes.sectionGap}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 20,
        }}
      >
        <div>
          <Typography variant="h6">Bônus por Performance</Typography>
          <Typography variant="body2" color="textSecondary">
            Configure bônus individuais ou em grupo
          </Typography>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <Button
            variant="outlined"
            startIcon={<PersonIcon />}
            onClick={() => addBonus(null)}
            style={{
              borderColor: COLORS.individual.primary,
              color: COLORS.individual.primary,
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            Bônus Individual
          </Button>
          <Button
            variant="outlined"
            startIcon={<GroupIcon />}
            onClick={createBonusGroup}
            style={{
              borderColor: COLORS.group.primary,
              color: COLORS.group.primary,
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            Criar Grupo
          </Button>
        </div>
      </div>

      {getIndividualBonuses().length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 12,
              paddingBottom: 8,
              borderBottom: `2px solid ${COLORS.individual.primary}`,
            }}
          >
            <PersonIcon style={{ color: COLORS.individual.primary, fontSize: 20 }} />
            <Typography variant="subtitle1" style={{ fontWeight: 600, color: COLORS.individual.primary }}>
              Bônus Individuais
            </Typography>
            <Chip
              label={getIndividualBonuses().length}
              size="small"
              style={{
                backgroundColor: COLORS.individual.primary,
                color: '#fff',
                height: 20,
                fontSize: 11,
              }}
            />
          </div>
          <div>
            {getIndividualBonuses().map((bonus, idx) => (
              <Paper
                key={bonus.originalIndex}
                variant="outlined"
                style={{
                  padding: 16,
                  marginBottom: idx === getIndividualBonuses().length - 1 ? 0 : 12,
                  backgroundColor: '#fff',
                  border: `1px solid ${COLORS.individual.border}`,
                  borderRadius: 8,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 12,
                  }}
                >
                  <Typography variant="body2" style={{ fontWeight: 600, color: '#555' }}>
                    Configuração do Bônus
                  </Typography>
                  <IconButton onClick={() => removeBonus(bonus.originalIndex)} size="small" style={{ color: '#999' }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Nome do Bônus"
                      value={bonus.name || ''}
                      onChange={e => updateBonus(bonus.originalIndex, 'name', e.target.value)}
                      placeholder="Ex: Bônus por KWh"
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Gatilho"
                      value={bonus.bonusTrigger}
                      onChange={e => updateBonus(bonus.originalIndex, 'bonusTrigger', e.target.value)}
                      placeholder="Ex: 1000"
                      type="number"
                      inputProps={{ step: '1', min: '0' }}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Valor (R$)"
                      type="text"
                      value={formatCurrencyInput(bonus.value)}
                      onChange={e => handleCurrencyChange(e, updateBonus, bonus.originalIndex, 'value')}
                      placeholder="500,00"
                      fullWidth
                      size="small"
                      variant="outlined"
                      InputProps={{
                        startAdornment: <span style={{ color: '#666', marginRight: 4 }}>R$</span>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth size="small" variant="outlined">
                      <InputLabel>Condição</InputLabel>
                      <Select
                        value={bonus.condition}
                        label="Condição"
                        onChange={e => updateBonus(bonus.originalIndex, 'condition', e.target.value)}
                      >
                        {ComissionBonusCondition.getValues().map(condition => (
                          <MenuItem key={condition} value={condition}>
                            {condition}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            ))}
          </div>
        </div>
      )}

      {aggregateBonusGroups.map((group, index) => (
        <Paper
          key={group.id}
          style={{
            marginTop: index === 0 && getIndividualBonuses().length === 0 ? 0 : 16,
            marginBottom: 16,
            padding: 16,
            backgroundColor: COLORS.group.light,
            border: `1px solid ${COLORS.group.border}`,
            borderRadius: 8,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 16,
              paddingBottom: 12,
              borderBottom: `1px solid ${COLORS.group.border}`,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <GroupIcon style={{ color: COLORS.group.chip, fontSize: 20 }} />
              <Chip
                label={group.name}
                size="small"
                style={{
                  backgroundColor: COLORS.group.chip,
                  color: '#fff',
                  fontWeight: 500,
                }}
              />
              <Typography variant="caption" color="textSecondary">
                {getBonusesByGroup(group.id).length} bônus
              </Typography>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => addBonus(group.id)}
                style={{
                  backgroundColor: COLORS.action,
                  color: '#fff',
                  textTransform: 'none',
                  boxShadow: 'none',
                }}
              >
                Adicionar Bônus
              </Button>
              <IconButton onClick={() => removeGroup(group.id)} size="small" style={{ color: '#999' }}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          </div>

          <div>
            {getBonusesByGroup(group.id).map((bonus, idx) => (
              <Paper
                key={bonus.originalIndex}
                elevation={0}
                style={{
                  padding: 12,
                  backgroundColor: '#fff',
                  marginBottom: idx === getBonusesByGroup(group.id).length - 1 ? 0 : 12,
                  border: '1px solid #e0e0e0',
                  borderRadius: 6,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 8,
                  }}
                >
                  <Typography variant="caption" style={{ fontWeight: 600, color: '#666' }}>
                    Bônus #{idx + 1}
                  </Typography>
                  <IconButton onClick={() => removeBonus(bonus.originalIndex)} size="small" style={{ color: '#bbb' }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Nome do Bônus"
                      value={bonus.name || ''}
                      onChange={e => updateBonus(bonus.originalIndex, 'name', e.target.value)}
                      placeholder="Ex: Bônus por KWh"
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Gatilho"
                      value={bonus.bonusTrigger}
                      onChange={e => updateBonus(bonus.originalIndex, 'bonusTrigger', e.target.value)}
                      placeholder="Ex: 1000"
                      type="number"
                      inputProps={{ step: '1', min: '0' }}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Valor (R$)"
                      type="text"
                      value={formatCurrencyInput(bonus.value)}
                      onChange={e => handleCurrencyChange(e, updateBonus, bonus.originalIndex, 'value')}
                      placeholder="500,00"
                      fullWidth
                      size="small"
                      variant="outlined"
                      InputProps={{
                        startAdornment: <span style={{ color: '#666', marginRight: 4 }}>R$</span>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth size="small" variant="outlined">
                      <InputLabel>Condição</InputLabel>
                      <Select
                        value={bonus.condition}
                        label="Condição"
                        onChange={e => updateBonus(bonus.originalIndex, 'condition', e.target.value)}
                      >
                        {/* Bônus em grupo só permitem condições de "Quantidade Mínima" (funcionam como faixas) */}
                        {ComissionBonusCondition.getAggregateValues().map(condition => (
                          <MenuItem key={condition} value={condition}>
                            {condition}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            ))}
            {getBonusesByGroup(group.id).length === 0 && (
              <div
                style={{
                  padding: 24,
                  textAlign: 'center',
                  backgroundColor: '#fff',
                  borderRadius: 6,
                  border: '1px dashed #ccc',
                }}
              >
                <Typography variant="body2" color="textSecondary">
                  Clique em Adicionar Bônus para adicionar bônus a este grupo
                </Typography>
              </div>
            )}
          </div>
        </Paper>
      ))}

      {formData.bonuses.length === 0 && aggregateBonusGroups.length === 0 && (
        <div
          style={{
            textAlign: 'center',
            padding: 48,
            backgroundColor: '#fafafa',
            borderRadius: 8,
            border: '1px dashed #ddd',
          }}
        >
          <AwardIcon style={{ fontSize: 48, opacity: 0.3, marginBottom: 16, color: '#666' }} />
          <Typography variant="body1" style={{ color: '#666' }}>
            Nenhum bônus configurado.
          </Typography>
          <Typography variant="body2" style={{ marginTop: 8, color: '#999' }}>
            Clique em Bônus Individual ou Criar Grupo para começar.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Bonus;
